<script>
    import {createEventDispatcher} from 'svelte';
    import Caja from "../../UI/Caja.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Boton from "../../UI/Boton.svelte";
    import Modal from "../../UI/Modal.svelte";
    import Icono from "../../UI/Icono.svelte";

    import {onMount} from 'svelte';
    import store from '../../../Stores/trabajador-store';
    import storeTrabajadores from '../../../Stores/trabajadores-store';
    import {nombreCompleto} from '../../../Modelos/Trabajador';
    import BuscadorDeTrabajadores from "../../UI/BuscadorDeTrabajadores.svelte";

    const dispatch = createEventDispatcher();

    let trabajadores;
    onMount(() => storeTrabajadores.cargar());
    $: trabajadores = $storeTrabajadores.listado.filter(x => x.id !== trabajador.id);

    let trabajador, nombre;
    $: trabajador = $store.trabajador;
    $: nombre = nombreCompleto(trabajador);

    let trabajadorOrigen = null;
    let seleccionandoTrabajador = false;
    const seleccionaTrabajador = () => seleccionandoTrabajador = true;
    const trabajadorElegido = e => {
        trabajadorOrigen = e.detail;
        seleccionandoTrabajador = false;
    };

    const recuperaDeTrabajador = () => {
        dispatch('copiar-de-trabajador', trabajadorOrigen);
        trabajadorOrigen = null;
    };

    const cancelaRecuperacion = () => {
        seleccionandoTrabajador = false;
        trabajadorOrigen = false;
        recuperandoEmpresa = false;
    };

    let recuperandoEmpresa = false;
    const recuperaDeEmpresa = () => {
        dispatch('restaurar-de-empresa');
        recuperandoEmpresa = false;
    };
</script>

<style>
    .advertencia {
        color: var(--acentos);
    }

    .trabajadores {
        display: flex;
        flex-direction: column;
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>Copia de calendario</Subtitulo>
    </div>

    <p>
        <Boton on:click={() => recuperandoEmpresa = true}>Restaurar de empresa</Boton>
    </p>

    <p>
        <Boton on:click={seleccionaTrabajador}>Copiar de otro trabajador</Boton>

        {#if seleccionandoTrabajador}
            <BuscadorDeTrabajadores on:change={trabajadorElegido}
                                    label="Selecciona el trabajador" value={trabajadorOrigen}
                                    {trabajadores}/>
        {/if}
    </p>
</Caja>

{#if recuperandoEmpresa }
    <Modal title="Restauración de calendario" estrecho on:cancel={cancelaRecuperacion}>
        <p>Se va a restaurar el calendario de la <strong>empresa</strong> para el trabajador
            <em>{nombre}.</em></p>
        <p class="advertencia">Esta acción no se puede deshacer</p>

        <div slot="footer">
            <Boton on:click={recuperaDeEmpresa} tipo="peligro">
                <Icono margen>check</Icono>
                Restaurar
            </Boton>

            <Boton on:click={cancelaRecuperacion} tipo="neutral">
                <Icono margen>cancel</Icono>
                Cancelar
            </Boton>
        </div>
    </Modal>
{/if}

{#if trabajadorOrigen }
    <Modal title="Restauración de calendario" estrecho
           on:cancel={cancelaRecuperacion}>
        <p>Se va a restaurar el calendario de
            <strong>{nombreCompleto(trabajadorOrigen)}</strong> para el trabajador <em>{nombre}
                .</em></p>
        <p class="advertencia">Esta acción no se puede deshacer</p>

        <div slot="footer">
            <Boton on:click={recuperaDeTrabajador} tipo="peligro">
                <Icono margen>check</Icono>
                Restaurar
            </Boton>

            <Boton on:click={cancelaRecuperacion} tipo="neutral">
                <Icono margen>cancel</Icono>
                Cancelar
            </Boton>
        </div>
    </Modal>
{/if}